<template>
  <b-dropdown-form
    class="py-1 dropdown-filter-form-n"
  >
    <b-row>
      <b-col cols="10">
        <p>Filters</p>
      </b-col>
      <b-col cols="2">
        <feather-icon
          icon="XIcon"
          size="16"
          class="align-right"
          @click="$emit('emitHideFilter')"
        />
      </b-col>
    </b-row>
    <b-form-group
      label="Product Description"
      @click.native.stop
    >
      <v-select
        v-model="fileTypeFilterValue"
        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
        label="value"
        multiple
        placeholder="Select from list"
        :options="productOptions"
        :clearable="false"
        :reduce="o => o.key"
      />
    </b-form-group>
    <b-form-group
      label="Invoice Status"
      @click.native.stop
    >
      <v-select
        v-model="invoiceStatusFilterValue"
        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
        label="value"
        multiple
        placeholder="Select from list"
        :options="invoiceStatusOptions"
        :clearable="false"
        :reduce="o => o.key"
      />
    </b-form-group>
    <b-form-group
      label="Invoice Date"
    >
      <b-input-group>
        <flat-pickr
          v-model="invoiceDateFilterValue"
          class="form-control"
          placeholder="Select Date Range"
          :config="flatPickrConfig"
        />
        <b-input-group-append is-text>
          <feather-icon
            icon="CalendarIcon"
            class="cursor-pointer"
            data-toggle
            size="18"
          />
        </b-input-group-append>
      </b-input-group>
    </b-form-group>
    <div class="d-flex justify-content-between gap-3 mt-2">
      <b-button
        variant="outline-primary"
        class="mr-1 w-50"
        @click="clearFilter"
      >
        Clear All
      </b-button>
      <b-button
        variant="primary"
        class="w-50"
        @click="applyFilter"
      >
        Apply Filter
      </b-button>
    </div>
  </b-dropdown-form>
</template>

<script>
import {
  BDropdownForm, BFormGroup, BButton, BRow, BCol, BInputGroup, BInputGroupAppend,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import '@core/scss/vue/libs/vue-flatpicker.scss'

export default {
  components: {
    BButton,
    BDropdownForm,
    BFormGroup,
    BRow,
    BCol,
    BInputGroup,
    BInputGroupAppend,
    vSelect,
    flatPickr,
  },
  props: {
    invoiceStatusFilter: {
      type: [Array, null],
      default: () => [],
    },
    fileTypeFilter: {
      type: [Array, null],
      default: () => [],
    },
    invoiceDateFilter: {
      type: [String, null],
      default: null,
    },
    invoiceStatusOptions: {
      type: Array,
      default: () => [],
    },
    productOptions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      invoiceDateFilterValue: this.invoiceDateFilter,
      invoiceStatusFilterValue: JSON.parse(JSON.stringify(this.invoiceStatusFilter)) || [],
      fileTypeFilterValue: JSON.parse(JSON.stringify(this.fileTypeFilter)) || [],
      flatPickrConfig: {
        wrap: true, mode: 'range', dateFormat: 'd/m/Y', enableTime: false, static: true, disableMobile: true,
      },
    }
  },
  watch: {
    invoiceDateFilter: {
      immediate: true,
      handler(val) {
        this.invoiceDateFilterValue = val
      },
    },
    invoiceStatusFilter: {
      immediate: true,
      handler(val) {
        this.invoiceStatusFilterValue = JSON.parse(JSON.stringify(val)) || []
      },
    },
    fileTypeFilter: {
      immediate: true,
      handler(val) {
        this.fileTypeFilterValue = JSON.parse(JSON.stringify(val)) || []
      },
    },
  },
  methods: {
    showAgainDropdown() {
      if (this.invoiceDateFilterValue) {
        this.$emit('emitShowFilter')
      }
    },
    applyFilter() {
      this.$emit('update:invoiceDateFilter', this.invoiceDateFilterValue)
      this.$emit('update:invoiceStatusFilter', this.invoiceStatusFilterValue)
      this.$emit('update:fileTypeFilter', this.fileTypeFilterValue)

      this.$emit('emitHideFilter')
    },
    clearFilter() {
      this.invoiceDateFilterValue = ''
      this.invoiceStatusFilterValue = []
      this.fileTypeFilterValue = []
      this.$emit('update:invoiceDateFilter', this.invoiceDateFilterValue)
      this.$emit('update:invoiceStatusFilter', this.invoiceStatusFilterValue)
      this.$emit('update:fileTypeFilter', this.fileTypeFilterValue)

      this.$emit('emitHideFilter')
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
